module.exports = __webpack_public_path__ + "static/media/Tile Image - KAL - 2 (1).26b3b082.jpg";